export default __webpack_public_path__ + "static/media/unlink.eb9fd716.svg";